// extracted by mini-css-extract-plugin
module.exports = {"splash_screen":"style_splash_screen__L23aQ"};